import { DesignSystem } from '@/src/design-system'

export default function SandboxPlaidOauthReplyScreen() {
  return <DesignSystem.Loading.Screen />
}
